import React , {Component} from 'react';
import { Row } from 'antd';
import "../../asset/style/morpheus.css"
import "../../asset/style/landing.css"

export class Contact extends Component {

    render(){
        return(
            <Row className="contact-parent full-widther">
                Contact
            </Row>
        )
    }
  }